module.exports = __webpack_public_path__ + "media/images/icons/open-door-fd9108d0de5f19567a4c7e97f0cf4cbe.svg";